import React, { useContext } from "react";
import { bool, string } from "prop-types";
import AssetsProvider from "@insightfulscience/atomic-react/utils/AssetsProvider";
import LandingSimpleSection from "./SimpleSection";

const LandingSimpleWithBackground = ({
	bgUrl,
	bgPosition = "center",
	bgRepeat = "no-repeat",
	bgSize = "cover",
	isBaseUrl = true,
	...props
}) => {
	const ctxBaseUrl = useContext(AssetsProvider.context);
	const baseUrl = isBaseUrl ? ctxBaseUrl : "";
	const styles = {
		backgroundImage: `url(${baseUrl}${bgUrl})`,
		backgroundSize: bgSize,
		backgroundPosition: bgPosition,
		backgroundRepeat: bgRepeat,
	};

	return <LandingSimpleSection style={styles} isBorderNone {...props} />;
};

LandingSimpleWithBackground.propTypes = {
	bgUrl: string.isRequired,
	bgPosition: string,
	bgRepeat: string,
	bgSize: string,
	isBaseUrl: bool,
};

export default LandingSimpleWithBackground;
